<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="生成外呼计划" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="400px">
    <div class="dialog__container">
      <el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
        label-width="120px">
        <el-form-item label="选择员工：" prop="people">
          <el-select
            size="mini"
            v-model="form.people"
            filterable
            placeholder="请选择员工"
            clearable
            reserve-keyword
            :remote="false"
            :remote-method="getUserSimpleListFun"
            @visible-change="getUserSimpleListFun('')"
            value-key="userId"
          >
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.nickname"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="计划完成时间：" prop="planFinishTime">
           <el-date-picker
                 v-model="form.planFinishTime"
                 type="datetime"
                 size="mini"
                 placeholder="选择计划完成时间"
                 format="yyyy-MM-dd HH:mm:ss"
                 value-format="yyyy-MM-dd HH:mm:ss">
               </el-date-picker>
         </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { createPlan } from "@/api/salesManagement/ProjectManagement";
import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
import { getUserSimpleList } from "@/api/ElevatorManagement";

export default {
  props: ['ids'],
  data() {
    return {
      form: {
        people: null,
        planFinishTime: null
      },
      addressWarn: false,
      rules: {

        people: [
          {
            required: true,
            message: "请选择员工",
            trigger: "change",
          },
        ],
        planFinishTime: [
          {
            required: true,
            message: "请选择计划完成时间",
            trigger: "change",
          },
        ],
      },
      userList: [],
      loadBtn: false
    };
  },
  components: {
    AddreassSelect,
  },
  created() {
    this.getUserSimpleListFun();
  },
  methods: {
    async getUserSimpleListFun(v = "") {
      this.canSearch = false;
      const res = await getUserSimpleList({ keyword: v, size: 200 });
      if (res.code === 200) {
        this.userList = res.data;
      }
      this.canSearch = true;
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await createPlan({
            projectIdSet:this.ids,
            operatorId: this.form.people.userId,
            operatorName: this.form.people.nickname,
            planFinishTime:this.form.planFinishTime
          });
          if (res.code === 200) {
            this.$message.success("生成成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/WHJH.vue